import { useQuery } from "@tanstack/react-query";
import { searchApi, type DualSearchResult } from "../search";

export const searchKeys = {
  all: ["search"] as const,
  dual: (searchId: string) => [...searchKeys.all, "dual", searchId] as const,
};

export function useDualSearch(searchId: string | null, enabled = true) {
  return useQuery<DualSearchResult[]>({
    queryKey: searchId ? searchKeys.dual(searchId) : ["search", "disabled"],
    queryFn: () => searchApi.dualSearch(searchId!),
    enabled: enabled && !!searchId && searchId.trim().length > 0,
    retry: false,
    staleTime: 0,
  });
}
